exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1R2wdCo0Sb13_oujmTEG4G{width:236px}.W6-iS-afJr8VTXtRvZyt-{color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"fixWidthContextMenu": "_1R2wdCo0Sb13_oujmTEG4G",
	"unscheduleText": "W6-iS-afJr8VTXtRvZyt-"
};